import { UntypedFormArray, ValidationErrors } from "@angular/forms";

export const arrayMinLength = (minLength: number = 1) => {
    return (control: UntypedFormArray): ValidationErrors | null => {
        return control.controls.length < minLength ? { arrayMinLength: minLength } : null;
    };
};
